<template>
    <div>
        <div class="flex flex-row gap-2 justify-end items-end mb-3">
            <v-button color="blue" icon="file-export" :disabled="isLoadingActiveTab || !permittingTypes.length" @click="exportActiveTab">
                <span v-if="!isLoadingActiveTab">{{ $t('export_active_tab') }}</span>
                <span v-else>
                    <i class="fa fa-spinner fa-spin"></i> {{ $t('loading') }}
                </span>
            </v-button>
            <v-button color="green" icon="file-export" :disabled="isLoadingTable" @click="exportTable">
                <span v-if="!isLoadingTable">{{ $t('export') }}</span>
                <span v-else>
                    <i class="fa fa-spinner fa-spin"></i> {{ $t('loading') }}
                </span>
            </v-button>
        </div>
        <b-tabs type="is-boxed" v-if="permittingTypes.length" v-model="activeTab">
            <b-tab-item v-for="tipo in permittingTypes" :key="tipo.id" :label="tipo.name">
                <permittings-table :typeId="tipo.id" :groups="tipo.groups" :projects="tipo.projects"
                    :key="'table_' + tipo.id" />
            </b-tab-item>
        </b-tabs>
        <div v-else class="has-text-centered py-6">
            <b-icon icon="loader" size="is-large" custom-class="fa-spin" />
            <div>{{ $t('permitting_not_configured') }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PermittingsTable from './permittings-table.vue'
import axios from 'axios'

export default {
    middleware: 'auth',
    title: 'permittings',
    menuOption: '2-1',
    components: { PermittingsTable },
    computed: {
        ...mapGetters({
            company: 'app/company',
        }),
    },
    data() {
        return {
            permittingTypes: [],
            isLoadingTable: false,
            isLoadingActiveTab: false,
            activeTab: 0,
        }
    },
    mounted() {
        this.loadPermittingTypes()
    },
    methods: {
        async loadPermittingTypes() {
            const { data } = await axios.get(`/api/v2/company/${this.company.id}/permitting-groups-projects`)
            this.permittingTypes = data.data
        },
        async exportTable() {
            this.isLoadingTable = true;
            try {
                const response = await axios.post(
                    '/api/v2/export/permittings-corporate-zone',
                    {
                        companyId: this.company.id,
                    },
                    { responseType: 'blob' }
                );
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'permittings_export.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                this.$buefy.toast.open({
                    message: this.$t('error_exporting'),
                    type: 'is-danger'
                });
            } finally {
                this.isLoadingTable = false;
            }
        },
        async exportActiveTab() {
            if (!this.permittingTypes.length) return;
            this.isLoadingActiveTab = true;
            const activeType = this.permittingTypes[this.activeTab];
            try {
                const response = await axios.post(
                    '/api/v2/export/permittings-corporate-zone',
                    {
                        companyId: this.company.id,
                        permittingTypeId: activeType.id,
                    },
                    { responseType: 'blob' }
                );
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `permitting_${activeType.name}_export.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                this.$buefy.toast.open({
                    message: this.$t('error_exporting'),
                    type: 'is-danger'
                });
            } finally {
                this.isLoadingActiveTab = false;
            }
        }
    }
}
</script>